export const aeraLayers = [
  {
    id: 'anticipate',
    number: '01',
    title: 'Anticipate',
    subtitle: 'Horizon scanning & predictive intelligence',
    description:
      'We scan emerging risks across cyber, climate, geopolitics, supply chains, and operations—so organizations see disruption before it arrives.',
    details: [
      'Emerging risk intelligence and horizon scanning',
      'Threat landscape monitoring across domains',
      'Predictive signals from operational and market data',
      'Board-ready early warning briefings',
    ],
  },
  {
    id: 'assess',
    number: '02',
    title: 'Assess',
    subtitle: 'Diagnostics, maturity & exposure',
    description:
      'Enterprise risk diagnostics, resilience maturity scoring, and quantified exposure—clarity on where you are vulnerable and how ready you are.',
    details: [
      'Resilience maturity assessments',
      'Enterprise risk diagnostics',
      'Exposure quantification and prioritization',
      'Gap analysis against leading practice',
    ],
  },
  {
    id: 'architect',
    number: '03',
    title: 'Architect',
    subtitle: 'Integrated protection design',
    description:
      'We design resilience architectures that combine governance, technology, insurance, and continuity planning into one coherent protection strategy.',
    details: [
      'Protection architecture design',
      'Insurance as a strategic layer—not the whole answer',
      'Governance and control frameworks',
      'Business continuity and crisis playbooks',
    ],
  },
  {
    id: 'activate',
    number: '04',
    title: 'Activate',
    subtitle: 'Response, crisis & recovery',
    description:
      'When disruption hits, we orchestrate incident response, crisis management, claims intelligence, and recovery—so downtime shrinks and confidence holds.',
    details: [
      'Incident and crisis response support',
      'Claims orchestration and intelligence',
      'Recovery coordination across stakeholders',
      'Communication and continuity activation',
    ],
  },
  {
    id: 'advance',
    number: '05',
    title: 'Advance',
    subtitle: 'Monitor, learn & optimize',
    description:
      'Continuous monitoring, analytics, and learning loops—so resilience compounds over time and your organization adapts faster than the risk landscape.',
    details: [
      'Real-time monitoring and dashboards',
      'Post-incident learning and optimization',
      'Resilience analytics and scorecards',
      'Continuous improvement of the architecture',
    ],
  },
];

export const aeraMeta = {
  name: 'AERA™',
  fullName: 'ALEgION Enterprise Resilience Architecture',
  tagline: 'Five integrated layers. One signature approach to organizational resilience.',
  summary:
    'AERA™ is ALEgION’s proprietary methodology for building enterprise resilience. Insurance is one component within a broader architecture—alongside intelligence, technology, governance, and recovery.',
};
